import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state = {
  countries: [],
  countriesLoading: false,
  clubs: [],
  clubsLoading: false,
  colleges: [],
  collegesLoading: false,
  states: [],
  statesLoading: false,
  collegeGpas: [],
  collegeGpasLoading: false,
  academicSpecialities: [],
  academicSpecialitiesLoading: false,
  divisions: [],
  divisionsLoading: false,
  collegeStates: [],
  collegeStatesLoading: false,
  schoolTypes: [],
  schoolTypesLoading: false,
  educationTypes: [],
  educationTypesLoading: false,
  collegeSettings: [],
  collegeSettingsLoading: false,
  ageGroups: [],
  ageGroupsLoading: false,
  playerPositions: [],
  playerPositionsLoading: false,
  playerStates: [],
  battingHands: [],
  throwingHands: [],
  playerStatesLoading: false,
  clubEventTypes: [],
  clubEventTypesLoading: false,
  collegeEventTypes: [],
  collegeEventTypesLoadinng: false
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
